var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceTemporalVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#workspace_temporal_video_svg__clip0_765_3804)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 21.09a.75.75 0 01-.75.75H7.073v.431a.75.75 0 01-1.5 0v-.43H1.25a.75.75 0 010-1.5h4.324v-.432a.75.75 0 011.499 0v.431H23.75a.75.75 0 01.75.75zM23.75.98H1.25a.749.749 0 00-.75.75v15.045a.75.75 0 00.75.75h22.5a.75.75 0 00.75-.75V1.73a.75.75 0 00-.75-.75zM7.99 5.69a1.426 1.426 0 012.14-1.234l6.165 3.561a1.424 1.424 0 010 2.467l-6.166 3.56a1.408 1.408 0 01-1.424 0 1.41 1.41 0 01-.714-1.233V5.69zm1.502 6.99v-6.86l5.94 3.43-5.94 3.43z",
    fill: "#24292E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "workspace_temporal_video_svg__clip0_765_3804"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgWorkspaceTemporalVideo;